import axios from 'axios';
// import router from '@/plugins/router';
import { utilityService } from '@/services/utilityService.js';
// import { authTokenService } from '@/services/authTokenService.js';
// import { iterator } from 'core-js/fn/symbol';

/**
 * Service to interact with the data analysis api.
 */
export const analysisApiService = {
	loadRecalls: (studyId, page, pageSize, sortBy, sortDir, userName, dateStart, dateEnd, recallStatuses) => __loadRecalls(studyId, page, pageSize, sortBy, sortDir, userName, dateStart, dateEnd, recallStatuses),
	loadTrackRespondents: (studyId, page, pageSize, sortDir, userName) => __loadTrackRespondents(studyId, page, pageSize, sortDir, userName),
	downloadAllAnalysisFiles: (studyId, studyResponseType, studyVersion) => __downloadAllAnalysisFiles(studyId, studyResponseType, studyVersion),
	downloadUserAnalysisFiles: (studyId, studyResponseType, studyVersion, userName) => __downloadUserAnalysisFiles(studyId, studyResponseType, studyVersion, userName),
	downloadDateRangeAnalysisFiles: (studyId, studyResponseType, studyVersion, startDate, endDate) => __downloadDateRangeAnalysisFiles(studyId, studyResponseType, studyVersion, startDate, endDate),
	downloadIdRangeAnalysisFiles: (studyId, studyResponseType, studyVersion, startId, endId) => __downloadIdRangeAnalysisFiles(studyId, studyResponseType, studyVersion, startId, endId)
	// createNutritionReport: (recallId, userName, recordNo, age, gender, energyProfile, breastFeed, pregnant) => __createNutritionReport(recallId, userName, recordNo, age, gender, energyProfile, breastFeed, pregnant)
};

function __loadRecalls (studyId, page, pageSize, sortBy, sortDir, userName, dateStart, dateEnd, recallStatuses) {
	let url = utilityService.getAnalysisApiUrl(`recall/report/track?studyId=${studyId}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}`);
	if (userName) {
		url += `&userName=${userName}`;
	}
	if (dateStart) {
		const ds = new Date(dateStart);
		url += `&dateStart=${ds.getMonth() + 1}/${ds.getDate()}/${ds.getFullYear()}`;
	}
	if (dateEnd) {
		const de = new Date(dateEnd);
		url += `&dateEnd=${de.getMonth() + 1}/${de.getDate()}/${de.getFullYear()}`;
	}
	if (recallStatuses) {
		url += '&recallStatuses=' + recallStatuses;
	}

	return axios.get(url,
		{
			headers: utilityService.getHeaders(false)
		});
}

function __downloadAllAnalysisFiles (studyId, studyResponseType, studyVersion = 21) {
	return axios.get(utilityService.getAnalysisApiUrl(`recall/report/download/study/all?studyId=${studyId}&studyResponseType=${studyResponseType}&studyVersion=${studyVersion}`),
		{
			responseType: 'blob',
			headers: utilityService.getHeaders(false)
		}
	);
}

function __downloadUserAnalysisFiles (studyId, studyResponseType, studyVersion = 21, userName) {
	return axios.get(utilityService.getAnalysisApiUrl(`recall/report/download/study/all?studyId=${studyId}&studyResponseType=${studyResponseType}&studyVersion=${studyVersion}&userName=${userName}`),
		{
			responseType: 'blob',
			headers: utilityService.getHeaders(false)
		}
	);
}

function __downloadDateRangeAnalysisFiles (studyId, studyResponseType, studyVersion = 21, startDate, endDate) {
	return axios.get(utilityService.getAnalysisApiUrl(`recall/report/download/study/all?studyId=${studyId}&studyResponseType=${studyResponseType}&studyVersion=${studyVersion}&dateStart=${startDate}&dateEnd=${endDate}`),
		{
			responseType: 'blob',
			headers: utilityService.getHeaders(false)
		}
	);
}

function __downloadIdRangeAnalysisFiles (studyId, studyResponseType, studyVersion = 21, startId, endId) {
	return axios.get(utilityService.getAnalysisApiUrl(`recall/report/download/study/all?studyId=${studyId}&studyResponseType=${studyResponseType}&studyVersion=${studyVersion}&startId=${startId}&endId=${endId}`),
		{
			responseType: 'blob',
			headers: utilityService.getHeaders(false)
		}
	);
}

function __loadTrackRespondents (studyId, page, pageSize, sortDir, userName) {
	let url = utilityService.getAnalysisApiUrl(`recall/report/track/respondents?studyId=${studyId}&page=${page}&pageSize=${pageSize}&sortDir=${sortDir}`);
	
	if (userName) {
		url += `&userName=${userName}`;
	}
	
	return axios.get(url,
		{
			headers: utilityService.getHeaders(false)
		});
}
